/**
 * External dependencies
 */
import React from 'react';

/**
 * Internal dependencies
 */

const ColumnChart = () => {
	return (
		<svg width='24' height='24' viewBox='0 0 80 80'>
			<rect fill='#fea58e' x='0' y='0' height='80' width='14'></rect>
			<rect fill='#51d3d9' x='20' y='18' height='62' width='14'></rect>
			<rect fill='#bda9ea' x='40' y='31' height='49' width='14'></rect>
			<rect fill='#f5c78e' x='60' y='50' height='30' width='14'></rect>
		</svg>
	);
};

export default ColumnChart;
